import { useIntl } from 'react-intl';
import { format } from 'date-fns';

import Chip from 'src/componentes/chip';
import useAuth from 'src/hooks/useAuth';
import formatDateFns from 'src/utils/formatDateFns';
import { capitalizeFirstLetter } from 'src/utils/string';
import { getDataAplicacaoFormularioGlobal } from 'src/paginas/avaliacao-desempenho/PesquisaClima/utils';
import { PERFIL_LIDERANCA } from '../ParticipantesPesquisaClimaTab/constants';

const getLookupLabel = (item) => item?.nome ?? item?.descricao;

const DashboardFiltroChips = ({ aplicacoes = [], filtros, onRemove }) => {
  const intl = useIntl();
  const { terms: resources, user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma, true);
  const chips = [];

  if (
    filtros.formularioUsoId != null &&
    filtros.formularioUsoId !== aplicacoes[0]?.formularioUsoId
  ) {
    const uso = aplicacoes.find(
      (item) => item.formularioUsoId === filtros.formularioUsoId
    );
    const dataInicio = getDataAplicacaoFormularioGlobal(uso?.dataInicio);
    if (dataInicio && !Number.isNaN(dataInicio.getTime())) {
      chips.push({
        key: 'formularioUsoId',
        label: `${intl.formatMessage({
          id: 'labelAplicacaoDashboard',
        })}: ${format(dataInicio, currentDisplay, { locale: currentLocale })}`,
      });
    }
  }

  ['tempoCargoDias', 'tempoEmpresaDias'].forEach((field) => {
    const value = filtros[field];
    if (value == null || value === '') return;

    chips.push({
      key: field,
      label: `${intl.formatMessage(
        { id: field },
        { cargo: resources.cargo }
      )}: ${intl.formatNumber(value)}`,
    });
  });

  ['cargos', 'areas'].forEach((field) => {
    if (!filtros[field]?.length) return;

    chips.push({
      key: field,
      label: `${capitalizeFirstLetter(resources[field])}: ${filtros[field]
        .map(getLookupLabel)
        .filter(Boolean)
        .join(', ')}`,
    });
  });

  if (filtros.areas?.length && filtros.considerarAreasSubordinadas) {
    chips.push({
      key: 'considerarAreasSubordinadas',
      label: capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.considerarAreasSubordinadas' },
          { areas: resources.areas }
        )
      ),
    });
  }

  const perfilLiderancaId = {
    [PERFIL_LIDERANCA.LIDERES]: 'labelPerfilLiderancaLideres',
    [PERFIL_LIDERANCA.NAO_LIDERES]: 'labelPerfilLiderancaNaoLideres',
  }[filtros.perfilLideranca];

  if (perfilLiderancaId) {
    chips.push({
      key: 'perfilLideranca',
      label: `${intl.formatMessage({
        id: 'labelPerfilLideranca',
      })}: ${intl.formatMessage({ id: perfilLiderancaId })}`,
    });
  }

  if (filtros.lideradosDe?.length) {
    chips.push({
      key: 'lideradosDe',
      label: `${intl.formatMessage({
        id: 'labelLideradosDe',
      })}: ${filtros.lideradosDe
        .map(getLookupLabel)
        .filter(Boolean)
        .join(', ')}`,
    });

    if (filtros.lideradosDiretos) {
      chips.push({
        key: 'lideradosDiretos',
        label: intl.formatMessage({
          id: 'labelLideradosDiretos',
        }),
      });
    }

    if (filtros.lideradosIndiretos) {
      chips.push({
        key: 'lideradosIndiretos',
        label: intl.formatMessage({
          id: 'labelLideradosIndiretos',
        }),
      });
    }
  }

  if (chips.length === 0) return null;

  return (
    <div
      className="d-flex flex-wrap align-items-center mb-3"
      style={{ gap: 8 }}
    >
      {chips.map(({ key, label }) => (
        <Chip
          key={key}
          label={label}
          title={label}
          onDelete={() => onRemove(key)}
        />
      ))}
    </div>
  );
};

export default DashboardFiltroChips;
